<template>
  <AddedToCartModal v-if="addedToCartModalStore.item" v-model:open="addedToCartModalStore.open" :item="addedToCartModalStore.item" />
</template>
<script setup lang="ts">
import { useAddToCartModal } from '~/stores/useAddToCartModal'
import AddedToCartModal from '~/components/molecules/AddedToCartModal.vue';

const addedToCartModalStore = useAddToCartModal()
</script>